import reactIcon from '../../Assets/images/skills/react.png';
import htmlIcon from '../../Assets/images/skills/html.png';
import cssIcon from '../../Assets/images/skills/css.png';
import bootstrapIcon from '../../Assets/images/skills/bootstrap.png';
import dotnetIcon from '../../Assets/images/skills/dotnet.png';
import sqlIcon from '../../Assets/images/skills/db.png';
import jsIcon from '../../Assets/images/skills/js.png';
import csharpIcon from '../../Assets/images/skills/csharp.png';
import angularIcon from '../../Assets/images/skills/angularjs.png';
import flutterIcon from '../../Assets/images/skills/flutter.png';
import nodeIcon from '../../Assets/images/skills/node.png';
import typescriptIcon from '../../Assets/images/skills/typescript.png';
import goIcon from '../../Assets/images/skills/go.png';
import xamarinIcon from '../../Assets/images/skills/xamarin.png';
import mauiIcon from '../../Assets/images/skills/maui.png';
import vscodeIcon from '../../Assets/images/skills/vscode.png';
import githubIcon from '../../Assets/images/skills/github.png';
import jiraIcon from '../../Assets/images/skills/jira.png';
import bitbucketIcon from '../../Assets/images/skills/bitbucket.png';
import ssmsIcon from '../../Assets/images/skills/ssms.png';

export const skillCat = {
	web: {
		categoryName: 'Web Development',
		percentage: 60,
		skillList: [
			{ name: 'HTML', xp: '5 YRS', icon: htmlIcon },
			{ name: 'CSS', xp: '4 YRS', icon: cssIcon },
			{ name: 'Javascript', xp: '4 YRS', icon: jsIcon },
			{ name: 'Bootstrap', xp: '5 YRS', icon: bootstrapIcon },
			{ name: 'C#', xp: '5 YRS', icon: csharpIcon },
			{ name: 'React js', xp: '2 YRS', icon: reactIcon },
			{ name: 'sql', xp: '4 YRS', icon: sqlIcon },
			{ name: '.net', xp: '4 YRS', icon: dotnetIcon },
			{ name: 'Angular', xp: '3 YRS', icon: angularIcon },
			{ name: 'Node js', xp: '3 YRS', icon: nodeIcon },
			{ name: 'TypeScript', xp: '1 YRS', icon: typescriptIcon },
			{ name: 'Go', xp: 'Basic', icon: goIcon },
		],
	},
	mobile: {
		categoryName: 'Mobile Development',
		percentage: 20,
		skillList: [
			{ name: 'Xamarin', xp: '3 YRS', icon: xamarinIcon },
			{ name: 'Flutter', xp: '1 YRS', icon: flutterIcon },
			{ name: '.NET MAUI', xp: '1 YRS', icon: mauiIcon },
		],
	},
	tools: {
		categoryName: 'Soft-Dev Tools',
		percentage: 20,
		skillList: [
			{ name: 'VS 2022 & VS Code Code', xp: '5 YRS', icon: vscodeIcon },
			{ name: 'Github', xp: '1 YRS', icon: githubIcon },
			{ name: 'JIRA', xp: '1 YRS', icon: jiraIcon },
			{ name: 'BitBucket', xp: '1 YRS', icon: bitbucketIcon },
			{ name: 'SSMS 19/20', xp: '1 YRS', icon: ssmsIcon },
		],
	},
	soft: {
		categoryName: ['Creative', 'Perseverant', 'Patient', 'Enthusiastic', 'Hardworking', 'Amusing'],
		percentage: 100,
	},
};
